<template>
    <v-container fluid grid-list-sm>
        <v-form ref="formAccesorio">
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="4" style="position: relative;z-index:100;">
                    <v-autocomplete label="Motivo *" color="textbox" v-model="obForm.idMotivo"
                        :items="listMotivoExclusion" item-text="motivoExclusion" item-value="idMotivoExclusion"
                        :rules="requeridoRegla" outlined dense />
                </v-col>
                <v-col cols="12" sm="6" v-show="parametros.id_motivo_exclusion_otros == parseInt(obForm.idMotivo)">
                    <v-text-field label="Detalle *" color="textbox" v-model="obForm.detalle"
                        :rules="parametros.id_motivo_exclusion_otros == parseInt(obForm.idMotivo) ? requeridoRegla : []"
                        outlined dense />
                </v-col>
            </v-row>
        </v-form>
        <v-row dense>
            <v-col xs12 sm12>
                <v-row dense align="center" justify="center">
                    <v-col xs12 sm4 v-for="(v,k) in listAccesorios" :key="_.uniqueId()+k">
                        <div class="text-center" style="position: relative; z-index: 100;">
                            <v-btn class="mx-2" x-small fab dark @click="excluirAccesorio(v);"
                                :style='v.add ? "background-color: #4caf50 !important;border-color: #4caf50 !important;" : "background-color: #EE4637 !important;border-color: #EE4637 !important;"'>
                                <v-icon dark v-if="v.add">check</v-icon>
                                <v-icon dark v-else>add</v-icon>
                            </v-btn>
                        </div>
                        <div class="text-center" style="position: relative;margin-top: -20px;">
                            <v-img :src="`data:image/svg+xml;base64,${v.icono}`" contain height="200" max-height="200" />
                        </div>
                        <div class="text-center" style="height:70px">
                            <p v-html="v.nombre_accesorio"></p>
                            <p v-show="!_.isNaN(parseFloat(v.valorAsegurado))">
                                <strong>Valor Asegurado</strong><br>
                                <span v-html="`$ ${v.valorAsegurado}`"></span>
                            </p>
                        </div>
                        <div class="text-center mt-2">
                            <p v-html="v.descripcion"></p>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name:'StepperExclusionAccesorioComponent',
        props: {
            load: {
                type: Boolean,
                default: false
            },
            parametros: {
                type: Object,
                default: {}
            },
            obSearch: {
                type: Object,
                default: {}
            },
            listMotivoExclusion: {}
        },
        data:() => ({
            obForm: {},
            listAccesorios: [],
            listAccesoriosExcluir: [],
        }),
        watch: {
            load(val) {
                if (val) {
                    if(!_.isUndefined(this.$refs.formAccesorio))
                        this.$refs.formAccesorio.resetValidation();

                    if (
                        parseInt(_.get(this.obForm, 'idCertificado', -1)) != parseInt(_.get(this.obSearch,'idCertificado', -2)) ||
                        parseInt(_.get(this.obForm, 'idPoliza', -1)) != parseInt(_.get(this.obSearch, 'idPoliza', -2))
                    ) {
                        this.$set(this, 'obForm', this.obSearch);
                        this.$set(this.obForm, 'idMotivo', null);
                        this.$set(this.obForm, 'detalle', '');
                        this.listarAccesoriosInclusion('L');
                    }
                }
            }
        },
        methods: {
            listarAccesoriosInclusion(event) {
                if (!_.isUndefined(event)) {
                    this.$set(this, 'listAccesorios', []);
                    var error = 'E';

                    var objeto = {
                        opcion: "LISTAR_INCLUSION_VEHICULO_VIGENTE_X_CERTIFICADO",
                        idCertificado: _.get(this.obForm, 'idCertificado', null),
                        idPoliza: _.get(this.obForm, 'idPoliza', null)
                    };

                    axios.post(`${BASE_URI}administrador/inclusion/listar`, objeto)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) {
                                error = 'I';
                                throw r.data.mensaje;
                            }
                            this.$set(this, 'listAccesorios', _.map(r.data.data, (v) => {
                                _.set(v, 'add', true);
                                _.set(v, 'index', _.uniqueId());
                                _.set(v, 'idMotivo', null);
                                _.set(v, 'detalle', '');
                                return v;
                            }));

                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        });
                }
            },
            excluirAccesorio(value) {
                if (!_.isUndefined(value)) {
                    var index = 0;
                    // Delete
                    if (!value.add) {
                        index = _.findIndex(this.listAccesoriosExcluir, { 'index': value.index });
                        this.$delete(this.listAccesoriosExcluir, index);

                        index = _.findIndex(this.listAccesorios, { 'index': value.index });
                        this.listAccesorios[index].add = true;
                    } else {
                        index = _.findIndex(this.listAccesorios, { 'index': value.index });
                        this.listAccesorios[index].add = false;
                        this.listAccesoriosExcluir.push(this.listAccesorios[index]);
                    }
                }
            },
            validacion() {
                try {
                    if (!this.$refs.formAccesorio.validate()) throw mensajeEstandar.corregirInformacion;
                    return true;
                } catch (error) {
                    mensajesAlerta(error, 'E');
                    return false;
                }
            }
        }
    }
</script>